<template>
		<div :style="`height: ${tabHeight}px;margin-bottom: 15px;`">
				<h3 style="margin: 5px 0;">Создание заявки</h3>
				<form :style="`height: ${formHeight}px;`" @submit.prevent="createTicket">
						<md-field style="width:600px;margin-bottom: 10px;">
								<label for="title">Тема</label>
								<md-input id="title" v-model="titleName" readonly></md-input>
						</md-field>
						<md-field style="width:180px; margin-bottom: 10px;">
								<label for="priority">Приоритет</label>
								<md-select
												placeholder="Приоритет"
												id="priority"
												name="priority"
												v-model="selectedPriority"
												md-dense
								>
										<md-option
														v-for="priority in PRIORITIES"
														:key="priority.id"
														:value="priority.name"
										>{{priority.name}}
										</md-option>
								</md-select>
						</md-field>
						<md-field md-clearable style="width:100%;height: 50%;margin: 10px 0;">
								<md-textarea
												style="resize:none; height: 100%; max-height: 100%;"
												id="message"
												placeholder="Текст сообщения"
												v-model.lazy.trim="message"
												rows="5"
												required
								></md-textarea>
						</md-field>
						<div id="attachments-link">
								<md-icon style="color: #000;">attach_file</md-icon>
								<span @click="clickFileInput()">Прикрепить файлы</span>
						</div>
						<md-field style="display: none">
								<label>Прикрепить файлы</label>
								<md-file id="file-input" @md-change="onFileUpload($event)" multiple/>
						</md-field>
						<transition name="fadeattachments">
								<div id="attachments-container" v-if="files">
										<div class="attachments-item" v-for="file of files" :key="file.name">
												<md-icon :md-src="`${calcTypeOfAttachment(file)}`" class="md-size-2x"/>
												<md-tooltip md-direction="bottom">{{file.name}} &#8195; {{bytesToSize(file.size)}}</md-tooltip>
												<span>{{file.name}} &nbsp; {{bytesToSize(file.size)}}</span>
												<span class="remove-attachment" @click="removeAttachment(file)">&times;</span>
										</div>
								</div>
						</transition>
						<md-button
										type="submit"
										class="md-dense md-raised md-primary md-theme-default"
										:disabled="!title || !message || inProcess"
						>Отправить
						</md-button>
				</form>
		</div>
</template>

<script>
	import {mapGetters} from "vuex";
	import axios from "axios";
	import {isEmpty, debounce} from '../utilities/utilities.js';

	export default {
		props: [],
		components: {},
		name: "newTicket",
		data: () => ({
			selectedPriority: "обычный",
			message: "",
			files: [], //прикрепленные файлы
			tabHeight: 600,
			formHeight: 100,
			windowHeight: 800,
			inProcess: false,
			title: {id: -1, name: 'Нет темы'}
		}),
        methods: {
            createTicket() {
				this.inProcess = true;
				axios
					.post(
						"data/CreateTicket",
						JSON.stringify({
							titleId: this.NEWTABTICKETTITLE.titleId,
							titleName: this.NEWTABTICKETTITLE.titleName,
							customer: this.CURRENTAPTEKA.npp,
							userId: this.USERID,
							state: "new",
							priority: this.npp,
							agent: "27", //Administrator по-умолчанию для новых заявок
							message: this.message,
							attachmentsData: this.attachmentsData.length > 0 ? JSON.stringify(this.attachmentsData) : '',
							idapt: this.CURRENTAPTEKA.idapt,
							clientEmails: this.createEmailsObject() ? JSON.stringify(this.createEmailsObject()) : ''
						}),
						{headers: {"Content-Type": "application/json"}}
					)
					.then(response => {
						if (response.data.statusCode > 200) {
							this.$store.dispatch("showSnackBar", {
								snackText: `Ошибка! создания новой заявки`
							});
							console.error(response.data.reasonPhrase);
							return;
						}
						let string = response.data.reasonPhrase;
						let arr = string.split(';');
						let ticketNpp = arr[1];
						let messageNpp = arr[2];
						let ticketNumber = arr[3];

						//сохраняем вложения на сервер
						if (this.files.length > 0) {
							this.uploadFilesToServer(this.files, ticketNpp, messageNpp)
								.then(response => {
									console.log(response);
								}, error => console.error(error))
								.finally(() => {
									//закрывем вкладку
									this.closeTab(this.CURRENTTABID);
									this.$emit("createTicket"); //обновление списка заявок
									this.$store.dispatch("showSnackBar", {snackText: `Создана заявка ${ticketNumber}`});
								});
						} else {
							//закрывем вкладку
							this.closeTab(this.CURRENTTABID);
							this.$emit("createTicket"); //обновление списка заявок
							this.$store.dispatch("showSnackBar", {snackText: `Создана заявка ${ticketNumber}`});
						}
					})
					.catch(error => {
						this.inProcess = false;
						console.error(error);
						this.$store.dispatch("showSnackBar", {
							snackText: "Ошибка создания новой заявки"
						});
					})
					.then(() => {
						// always executed
					});
			},
			closeTab(tab_id) {
				this.$emit("closeTab", tab_id);
				// this.$store.dispatch("SET_HASCREATETICKETTAB", false); //делаем активной кнопку "Создать заявку"
			},
			onFileUpload(fileList) {
				Array.from(fileList).forEach(file => {
					this.files.push(file);
				});
				this.on_resize();
			},
			uploadFilesToServer(files, ticketNpp, messageNpp) {
				let formData = new FormData();
				files.forEach(file => formData.append('files', file));
				formData.append('ticketNpp', ticketNpp);
				formData.append('messageNpp', messageNpp);

				return this.$http.post('data/UploadAttachmentsFiles', formData);
			},
			calcTypeOfAttachment(file) {
				let fileName = file.name;
				//определяем расширение файла
				let fileType = fileName.slice((Math.max(0, fileName.lastIndexOf(".")) || Infinity) + 1);
				fileType = fileType.toLowerCase();
				return this.KNOWNFILETYPES.includes(fileType) ? `/dist/svg/${fileType}.svg` : `/dist/svg/raw.svg`;
			},
			clickFileInput() {
				document.getElementById('file-input').click();
			},
			removeAttachment(attachment) {
				let index = this.files.indexOf(attachment);
				if (index !== -1) this.files.splice(index, 1);
				this.on_resize();
			},
			bytesToSize(bytes) {
				const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
				if (bytes === 0) return 'n/a';
				const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10);
				if (i === 0) return `${bytes} ${sizes[i]}`;
				return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
			},
			createEmailsObject() {
				let obj = Object.create(null);
				if (this.clientEmail) obj['to'] = [this.clientEmail];
				return !isEmpty(obj) ? obj : null;
			},
			calcDomElemHeight(domElem) {
				return domElem ? domElem.clientHeight : 0;
			},
			calcTabHeight() {
				const pageHeight = this.windowHeight;
				const applicationToolbarHeight = this.calcDomElemHeight(document.getElementById("application-toolbar"));
				const secondTabsPanelHeight = this.calcDomElemHeight(document.getElementById("second-tabs-panel"));
				const progressBarHeight = this.calcDomElemHeight(document.getElementById('tickets-progress-bar'));
				const siteVersionToolbarHeigth = this.calcDomElemHeight(document.getElementById('site-version-toolbar'));
				const attachmentsContainerHeight = this.calcDomElemHeight(document.getElementById('attachments-container'));
				this.tabHeight = pageHeight - applicationToolbarHeight - secondTabsPanelHeight - progressBarHeight - siteVersionToolbarHeigth + attachmentsContainerHeight;
			},
			calcFormHeight() {
				const h3Height = this.calcDomElemHeight(document.querySelector('h3'));
				const attachmentsContainerHeight = this.calcDomElemHeight(document.getElementById('attachments-container'));
				const paddingMargingHeight = 50;
				this.formHeight = this.tabHeight - h3Height - attachmentsContainerHeight - paddingMargingHeight;
			},
			async on_resize() {
				// console.log('resize');
				await this.$nextTick();
				const documentElement = document.documentElement;
				this.windowHeight = documentElement ? documentElement.clientHeight : 800;
				this.calcTabHeight();
				this.calcFormHeight();
			}
		},
		computed: {
			...mapGetters([
				"LAST_NUMBER",
				"PRIORITIES",
				"CURRENTTABID",
				"CURRENTAPTEKA",
				'USERID',
				'KNOWNFILETYPES',
				'CURRENTUSER',
				'NEWTABTICKETTITLE'
			]),
			titleName: {
				get() {
					return this.NEWTABTICKETTITLE.titleName;
				},
				set(val) {

				}
			},
			npp() {
				switch (this.selectedPriority) {
					case "самый низкий":
						return "very_low";
					case "низкий":
						return "low";
					case "обычный":
						return "normal";
					case "высокий":
						return "hight";
					case "безотлагательный":
						return "very_hight";
				}
			},
			attachmentsData() {
				let attacmentsData = [];
				this.files.forEach(file => {
					let {name: file_name, size: file_size, type: file_type} = file;
					attacmentsData.push({file_name, file_size, file_type});
				});
				return attacmentsData;
			},
            clientEmail() {
                const a = this.CURRENTAPTEKA
                return (a && a.email? 'fz:' + a.email : null) || this.CURRENTUSER.email || '';
			}
		},
		async mounted() {
			if (this.PRIORITIES.length === 0) this.$store.dispatch("GET_PRIORITIES");

			var title = JSON.parse(localStorage.newTabTicketTitle);
			this.$store.dispatch("SETNEWTABTICKETTITLEA", title);

			//блок расчета высоты tab элемента и формы
			await this.$nextTick();
			window.addEventListener('resize', debounce(this.on_resize, 250));
			this.on_resize();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.on_resize);
			// console.log("newTicket beforeDestroy()");
			// this.$root.$off("closeTabFromParent", this.closeTabFromParent);
		}
	};
</script>

<style lang="scss" scoped>
		#attachments-container {
				display: flex;
				flex-wrap: wrap;
				margin-bottom: 10px;
		}

		.attachments-item {
				padding: 5px;
				height: 100px;
				width: 100px;
				border: 1px solid #DADADA;
				background-color: #F0F0F0;
				border-radius: 5px;
				margin-right: 10px;
				position: relative;
				display: flex;
				flex-direction: column;
		}

		.attachments-item span {
				font-size: 10px;
				white-space: nowrap;
				overflow: hidden;
		}

		.attachments-item span.remove-attachment {
				height: 16px;
				width: 16px;
				position: absolute;
				top: 0;
				right: 0;
				text-align: center;
				line-height: 16px;
				font-size: 18px;
				border-radius: 8px;
		}

		.attachments-item span.remove-attachment:hover {
				cursor: pointer;
				background-color: #448AFF;
				color: white;
		}

		#attachments-link {
				margin-bottom: 10px;
		}

		#attachments-link span {
				text-decoration: underline;
				padding: 10px 10px 10px 0;
		}

		#attachments-link span:hover {
				cursor: pointer;
				text-decoration: none;
		}

		.fadeattachments-enter-active, .fadeattachments-leave-active {
				transition: opacity .5s;
		}

		.fadeattachments-enter, .fadeattachments-leave-to {
				opacity: 0;
		}
</style>


// WEBPACK FOOTER //
// Components/supportNew/newTicket.vue